// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const ArrowNarrowLeftIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "ArrowNarrowLeft/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m7 16-4-4m0 0 4-4m-4 4h18"
}));
export default ArrowNarrowLeftIcon;